import { HttpParamsObject } from '../api/api.service';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { Inject, Injectable, Optional } from '@angular/core';
import { FhirApiService } from '../api/fhir-api.sevice';
import { ConsentService } from './consent.service';
import { UserService } from '../user.service';
import { OrganizationAdapter } from '../../data/providers/organization.model';
import { FacilitiesService } from '../../data/providers/facilities.service';
import { Observable } from 'rxjs';
import { ReducerManager, Store } from '@ngrx/store';
import { Organization } from '@xt/domain-model';

@Injectable({ providedIn: 'root' })
export class ConsentFacilitiesService extends FacilitiesService {
  consentProviderIdentifiers$: Observable<string[]>;

  constructor(
    @Inject('dataname') @Optional() dataName: string,
    protected adapter: OrganizationAdapter,
    protected fhirApi: FhirApiService,
    protected userService: UserService,
    protected consentService: ConsentService,
    protected store: Store,
    protected manager: ReducerManager,
  ) {
    super(
      dataName || 'consent-facilities',
      adapter,
      fhirApi,
      userService,
      store,
      manager,
    );
  }

  fetchFacilitiesWithConsentData(
    paramsObject?: HttpParamsObject,
  ): Observable<Organization[]> {
    return this.consentService.fetchConsentData$().pipe(
      map((permissions) =>
        permissions
          .map(({ facilityId }) => facilityId)
          .filter((facilityId) => facilityId),
      ),
      switchMap((identifiers) => {
        const identifier = identifiers.join(',') || null;

        return this.searchItems$({ ...paramsObject, identifier }).pipe(
          take(1),
          catchError((err) => {
            this.setError(err);
            throw new Error(err);
          }),
        );
      }),
    );
  }
}
